import type { School } from './school'

export const SCHOOLS_REGISTRY: School[] = [
  {
    id: 'uh',
    name: 'University of Houston',
    shortName: 'UH',
    color: '#C8102E',
    location: 'Houston, TX',
    isActive: true,
    addedAt: '2024-01-01',
  },
  {
    id: 'utaustin',
    name: 'University of Texas at Austin',
    shortName: 'UT Austin',
    color: '#BF5700',
    location: 'Austin, TX',
    isActive: false,
    addedAt: '2024-01-01',
  },
  {
    id: 'tamu',
    name: 'Texas A&M University',
    shortName: 'TAMU',
    color: '#500000',
    location: 'College Station, TX',
    isActive: false,
    addedAt: '2024-01-01',
  },
  {
    id: 'rice',
    name: 'Rice University',
    shortName: 'Rice',
    color: '#00205B',
    location: 'Houston, TX',
    isActive: false,
    addedAt: '2024-01-01',
  },
]
